import React, { useState, useEffect } from "react";
import axios from "axios";
import Approved from "../../../assets/images/approved.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LiveChatApproved = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  
  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/live_chat/live`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Approved Live Chat"
        image={Approved}
        count={count}
      />
      {buffer ? (
          <LoaderPost />
        ) : (
      <AllModuleData
        data={event_data}
        urlLink={`/superstar-admin/live-chat/details`}
      />
      )}
    </>
  );
};

export default LiveChatApproved;
